  // PC スライド画像幅 1000px を基準に centerPadding を動的計算
  // centerPadding = (画面幅 - 1000px) / 2 → 中央スライドが常に1000px固定
  function calcCenterPadding() {
    var slideWidth = 1030;
    var vw = window.innerWidth;
    if (vw <= slideWidth) return '0px';
    return Math.floor((vw - slideWidth) / 2) + 'px';
  }

  function initOkrSlider() {
    var $slider = $('.okr_slider');
    
    // JSファイルが非同期(defer)で読み込まれる際の遅延対策
    if (typeof $slider.slick !== 'function') {
      setTimeout(initOkrSlider, 100);
      return;
    }

    // テーマエディタでの再読み込み時は、一度破棄してから再構築する
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: false,
      dots: true,
      centerMode: true,
      centerPadding: calcCenterPadding(),
      responsive: [
        {
          breakpoint: 999, // 画面幅が999px以下の場合
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px',
          },
        },
      ],
    });
  }

  $(document).ready(function () {
    initOkrSlider();

    // リサイズ時に centerPadding を再計算
    $(window).on('resize', function () {
      if (window.innerWidth >= 1030 && $('.okr_slider').hasClass('slick-initialized')) {
        $('.okr_slider').slick('slickSetOption', 'centerPadding', calcCenterPadding(), true);
      }
    });

    // 画面ロック解除時に再計算（visibilitychange）
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && window.innerWidth >= 1030 && $('.okr_slider').hasClass('slick-initialized')) {
        $('.okr_slider').slick('slickSetOption', 'centerPadding', calcCenterPadding(), true);
      }
    });

    // bfcache（戻るボタン等）で復元された場合にも再計算
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && window.innerWidth >= 1030 && $('.okr_slider').hasClass('slick-initialized')) {
        $('.okr_slider').slick('slickSetOption', 'centerPadding', calcCenterPadding(), true);
      }
    });
  });

  // Shopifyテーマエディタでセクションが追加・変更された時に再発火
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.okr_slider')) {
      initOkrSlider();
    }
  });
